import React, {useCallback, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Button} from "@mui/material";
import Typography from "@mui/material/Typography";
import {ReactComponent as SawIcon} from "../../../../../components/Icons/processing.svg";
import {useNavigate} from "react-router-dom";
import DateTimeUtil from "../../../../../utils/common/DateTimeUtil";
import DateRangeFilter from "../../../filter/DateRangeFilter";
import ModalUpdateStatus from "../ModalUpdateStatus";
import OptimizationService from "../../../../../API/orders/optimization/organization/OptimizationService";
import {optimizationStateStatuses} from "../../../../../data/OptizationState";
import ModalOpenCreatePlanOrOptimization from "../plans/ModalOpenCreatePlanOrOptimization";
import selectionTableUtil, {normalizeSelection} from "../../../../../utils/common/SelectionTableUtil";
import MenuItem from "@mui/material/MenuItem";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {ruRU} from "@mui/x-date-pickers/locales";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import ButtonCreate from "../../../button/ButtonCreate";
import Crop32Icon from '@mui/icons-material/Crop32';
import {materialEstimateUnitStates} from "../../../../../data/MaterialEstimateUnitState";
import WorkingCuttingMapService from "../../../../../API/orders/cutting/cuttingmap/WorkingCuttingMapService";
import ModalConfirm from "../../../modal/ModalConfirm";

const OptimizationTable = ({
                               data,
                               setData,
                               isCreateCreateOptimization,
                               isRedirectPlans,
                               isCalculation,
                               rowSelection,
                               setRowSelection,
                               tableOptions,
                               tableOptionsHandle,
                               handleModalAlert,
                               isArchive,
                               statusList,
                               globalFilter,
                               handleSearchQuery,
                               filteredData,
                               columnsFilter,
                           }) => {
        const [updateModalOpen, setUpdateModalOpen] = useState(false);
        const [currentEditRowData, setCurrentEditRowData] = useState(null);
        const [currentAllowedStatuses, setCurrentAllowedStatuses] = useState(['ARCHIVE']);
        const [currentEditRowId, setCurrentEditRowId] = useState(null);
        const [addModalOpen, setAddModalOpen] = useState(false);
        const [newRowData, setNewRowData] = useState(null);
        const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
        const currentSelection = normalizeSelection(rowSelection)
        const [createCuttingMapsModalOpen, setCreateCuttingMapsModalOpen] = useState(false);
        const [showColumnFilters, setShowColumnFilters] = useState(false)
        const [loading, setLoading] = useState(false)

        const handleShowColumnFilters = () => {
            setShowColumnFilters(!showColumnFilters)
            if (showColumnFilters) {
                handleSearchQuery([], data, null, true)
            }
        }

        const handleDeleteRow = useCallback(
            (row) => {
                const id = row.id;
                OptimizationService.delete(id)
                    .then(function () {
                        const newData = data.filter(el => el.id !== id)
                        setData(newData)
                        handleSearchQuery(globalFilter, newData)
                        handleModalAlert("Данные удалены", 'success')
                    })
                    .catch(function (error) {
                        handleModalAlert(error);
                    })
            },
            [data],
        );

        const handleUpdateModel = useCallback(
            (row) => {
                setCurrentAllowedStatuses([...currentAllowedStatuses, row.optimizationState]);
                setCurrentEditRowData(row);
                setCurrentEditRowId(row.id);
                setUpdateModalOpen(true);
            },
            [data, currentEditRowData, setCurrentEditRowData],
        );

        const handleClose = () => {
            currentAllowedStatuses.splice(1, 1);
            setUpdateModalOpen(false)
        };

        const navigate = useNavigate();

        const redirectOptimizationsCalculationArchive = () => {
            navigate('/organization/optimizations-calculation-archive');
        };

        const redirectOptimizationsArchive = () => {
            navigate('/organization/optimizations-archive');
        };

        const handleCreateOptimization = () => {
            const optimization = {
                id: null,
                number: "OP",
                optimizationState: 'EXPECTATION',
                optimized: null,
            }
            setNewRowData(optimization);
            setAddModalOpen(true)
        };

        const createOptimization = () => {
            setLoading(true)
            OptimizationService.createOptimization(newRowData,).then(function (response) {
                const newData = [...data, response.data]
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                setAddModalOpen(false)
                handleModalAlert("Оптимизация создана", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        };

        const handleArchive = (row) => {
            OptimizationService.setArchive([row.id])
                .then(function () {
                    const newData = data.filter(el => row.id !== el.id)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    handleModalAlert("Перемещено в архив", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        }

        const columns = useMemo(
            () => [
                {
                    id: 'number',
                    header: 'Номер',
                    accessorKey: 'number',
                    minSize: 300,

                },
                {
                    id: 'requests_cutting',
                    header: 'Заявки на раскрой',
                    accessorKey: 'requests_cutting',
                    minSize: "50px",
                    enableSorting: false,
                    enableColumnActions: false,
                    Cell: ({row}) => (
                        <Button
                            onClick={() => navigate(`/organization/requests-cutting/optimization/${row.original.id}/${encodeURIComponent(row.original.number)}${isCalculation ? "/calculation" : ""}`)}>
                            <SawIcon style={{width: "30px", height: "30px"}}/>
                        </Button>
                    ),
                },
                {
                    id: 'details_cutting',
                    header: 'Детали на раскрой',
                    accessorKey: 'details_cutting',
                    minSize: "50px",
                    enableSorting: false,
                    enableColumnActions: false,
                    Cell: ({row}) => (
                        <Button
                            sx={{padding: 0}}
                            onClick={() => navigate(`/organization/details/optimization/${row.original.id}/${encodeURIComponent(row.original.number)}`)}>
                            <Crop32Icon style={{color: "black", fontSize: "42px"}}/>
                        </Button>
                    ),
                },
                {
                    accessorFn: (row) => {
                        if (row.optimized === null) {
                        } else {
                            return new Date(row.optimized)
                        }
                    },
                    id: 'optimized',
                    header: 'Дата оптимизации',
                    accessorKey: 'optimized',
                    sortingFn: 'datetime',
                    size: 300,
                    Cell: ({cell}) => {
                        if (cell.getValue() !== undefined) {
                            return cell.getValue().toLocaleDateString();
                        }
                    },
                    Filter: ({column}) => <DateRangeFilter
                        column={column}
                    />,
                },
                {
                    id: 'optimizationState',
                    header: 'Статус',
                    accessorKey: 'optimizationState',
                    minSize: 350,
                    filterVariant: 'multi-select',
                    filterSelectOptions: statusList,
                    Cell: ({cell}) => optimizationStateStatuses[cell.getValue()],
                    muiFilterTextFieldProps: {
                        placeholder: 'Отфильтровать по статус',
                        sx: {
                            width: '350px',
                        },
                    }
                },
                {
                    header: 'id',
                    accessorKey: 'id',
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableEditing: false,
                    size: 2,
                    maxSize: 2,
                },
            ],
            [data, setData, filteredData],
        );
        const handleCloseCuttingMaps = () => {
            setCurrentEditRowData(null);
            setCreateCuttingMapsModalOpen(false)
        }
        const handleCreateCuttingMaps = (row) => {
            setCurrentEditRowData(row);
            setCreateCuttingMapsModalOpen(true)
        }

        const handleSubmitCreateCuttingMaps = async () => {
            setLoading(true)
            WorkingCuttingMapService.createByIdsOptimization([currentEditRowData?.id], isCalculation)
                .then(function () {
                    const newData = data.map(item => currentEditRowData?.id === item.id ? {
                        ...item,
                        optimizationState: isCalculation ? "CREATED_CUTTING_MAP_CALCULATION" : 'CREATED_CUTTING_MAP'
                    } : item)
                    setData(newData);
                    handleSearchQuery(globalFilter, newData)
                    handleCloseCuttingMaps()
                    handleModalAlert("Карты созданы", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(true))
        }

        const menuItem = isCalculation ? [
            {type: "edit", text: "Создать расчетные карты раскроя", handler: handleCreateCuttingMaps},
            {type: "edit", text: "Редактировать", handler: handleUpdateModel},
            {type: "delete", text: "Удалить", handler: handleDeleteRow},
        ] : [
            {type: "edit", text: "Создать карты раскроя", handler: handleCreateCuttingMaps},
            {type: "edit", text: "Редактировать", handler: handleUpdateModel},
            {type: "delete", text: "Удалить", handler: handleDeleteRow},
            {type: "archive", text: "Отправить в архив", handler: handleArchive}
        ]

        return (
            <Box sx={{maxWidth: "1500px"}}>
                <Box
                    sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
                >
                    <Box sx={{display: 'flex', justifyContent: "spase-between", gap: "9px"}}>
                        <ButtonCreate
                            text={"Заказы"}
                            width={70}
                            icon={false}
                            onClick={() => navigate('/organization/orders')}
                        />
                        {!isCalculation && <ButtonCreate
                            text={"Заявки на раскрой"}
                            width={160}
                            icon={false}
                            onClick={() => navigate('/organization/requests-cutting')}
                        />}
                        {isCalculation && <ButtonCreate
                            text={"Заявки на просчет"}
                            width={160}
                            icon={false}
                            onClick={() => navigate('/organization/requests-cutting/calculation')}
                        />}

                        {isRedirectPlans && <ButtonCreate
                            text={"Планы"}
                            width={70}
                            icon={false}
                            onClick={() => navigate('/organization/plans')}
                        />}
                        {!isCalculation && <ButtonCreate
                            text={"Карты раскроя"}
                            width={130}
                            icon={false}
                            onClick={() => navigate('/organization/working-cutting-maps')}
                        />}
                        {isCalculation && <ButtonCreate
                            text={"Расчетные карты раскроя"}
                            width={220}
                            icon={false}
                            onClick={() => navigate('/organization/working-cutting-maps-calculation')}
                        />}
                        {isCreateCreateOptimization && <ButtonCreate
                            text={"Создать оптимизацию"}
                            width={230}
                            onClick={handleCreateOptimization}
                        />}
                        {!isArchive && <ButtonCreate
                            text={"Архив"}
                            width={70}
                            icon={false}
                            onClick={isCalculation ? redirectOptimizationsCalculationArchive : redirectOptimizationsArchive}
                        />}
                    </Box>
                </Box>
                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale='ru'
                    localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>
                    <MaterialReactTable
                        renderTopToolbar={({table}) => {
                            return <Box sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "7px",
                                backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                            }}>
                                <MRT_ToolbarAlertBanner table={table}/>
                                <Box sx={{display: "flex"}}>
                                    <MRT_ToggleFiltersButton table={table}/>
                                    <MRT_GlobalFilterTextField table={table}/>
                                </Box>
                            </Box>
                        }}
                        selectAllMode={"all"}
                        muiTableContainerProps={{
                            sx: {
                                maxHeight: `calc(100vh - 600px)`,
                                width: "1500px"
                            }
                        }}
                        muiToolbarAlertBannerProps={{
                            sx: {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "& .MuiStack-root": {
                                    padding: 0,
                                    "& .MuiBox-root": {
                                        padding: "5px"
                                    }
                                },

                            }
                        }}
                        muiTableBodyCellProps={({cell, table}) => {
                            return ({
                                sx: () => ({
                                    p: '0px 0px 0px 10px',
                                    m: '0px 0px 0px 0px',
                                    border: "none",
                                    "&:after": {
                                        display: "none",
                                    },
                                    "& td:after": {
                                        "&:hover": {
                                            backgroundColor: "red"
                                        }
                                    },
                                    "&:not(:last-of-type)": {
                                        borderRight: '1px solid #EAEBEA',
                                    },
                                    "&": (cell.column.id === "requests_cutting" || cell.column.id === "details_cutting") && {
                                        width: 'calc(100% - 1px)',
                                        padding: "0 50px"
                                    },

                                    "&:first-of-type": !isArchive && {
                                        padding: 0,
                                        width: "50px",
                                        height: "36px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: (theme) => theme.palette.text.light,
                                        "& .MuiButtonBase-root": {
                                            borderRadius: "4px",
                                            width: "24px",
                                            height: "24px",
                                            opacity: 1,
                                            margin: 0,
                                            padding: 0,
                                            "&:hover": {
                                                backgroundColor: (theme) => theme.palette.primary.stroke,
                                            }
                                        }
                                    },

                                    "& a": {
                                        color: "#006CCC",
                                        textDecoration: "none",
                                        "&:hover": {
                                            textDecoration: "underline"
                                        }

                                    }
                                })
                            })
                        }}
                        muiTableHeadCellProps={{
                            sx: {
                                border: '1px solid #EAEBEA',
                                backgroundColor: "#F5F6FA",
                                padding: "10px",
                                paddingBottom: " 0.2rem",
                                paddingTop: "0.2rem",
                                "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                                    "minWidth": "100%"
                                },
                                "& .MuiCollapse-root .MuiSelect-select": {
                                    padding: "0 !important",
                                    "& .MuiChip-label": {
                                        paddingLeft: "5px",
                                        paddingRight: "5px",
                                    }
                                }
                            },
                        }}
                        muiTableBodyRowProps={({row}) => {
                            return ({
                                sx: () => ({
                                    height: '36px',
                                    backgroundColor: "white",
                                    "&:hover& td:after": {
                                        display: "none",
                                    },
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light70,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    "&:hover": {
                                        "& td:after": {
                                            display: "none",
                                        },
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                    '&:nth-of-type(even)': {
                                        "&.MuiTableRow-root.Mui-selected": {
                                            backgroundColor: (theme) => theme.palette.primary.light,
                                            "&:hover": {
                                                backgroundColor: (theme) => theme.palette.primary.light50,
                                            },
                                        },
                                        backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        },
                                    },
                                })
                            })
                        }}

                        muiSearchTextFieldProps={{
                            placeholder: `Поиск`,
                            sx: {
                                paddingTop: "5px",
                                paddingBottom: "0px",
                                "& .MuiCollapse-root": {
                                    borderRadius: '12px',
                                    height: 40, width: 290,
                                    "& .MuiSvgIcon-root": {
                                        color: "#737478"
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        padding: 0
                                    }
                                }
                            },
                            variant: 'outlined',
                        }}
                        displayColumnDefOptions={{
                            'mrt-row-actions': {
                                header: "",
                                size: 3,
                                minSize: 3,
                                grow: false,
                            },
                            'mrt-row-select': {
                                size: "50px",
                                grow: false,
                            },
                        }}
                        columns={columns}
                        data={filteredData}
                        enableRowSelection={!isArchive}
                        rowHeight={13}
                        columnSpacing={1}
                        initialState={{
                            columnVisibility: {
                                id: false,
                            },
                            isFullScreen: false,
                            density: "compact",
                        }}
                        onRowSelectionChange={onRowSelectionChange}
                        getRowId={(originalRow) => originalRow.id}
                        onPaginationChange={(updater) => {
                            tableOptionsHandle(updater(tableOptions));
                        }}
                        onGlobalFilterChange={(value) => {
                            handleSearchQuery(value, data, null)
                        }}
                        onColumnFiltersChange={(updater) => {
                            handleSearchQuery(updater(columnsFilter), data, null, true)
                        }}
                        onShowColumnFiltersChange={handleShowColumnFilters}
                        state={{
                            showColumnFilters: showColumnFilters,
                            columnFilters: columnsFilter,
                            globalFilter: globalFilter,
                            rowSelection: currentSelection,
                            showGlobalFilter: true,
                            pagination: tableOptions,
                        }}
                        manualFiltering={true}
                        rowCount={tableOptions.totalElements}
                        selectionPadding={1}
                        enableRowActions={!isArchive}
                        enableToolbarInternalActions={false}
                        selectionCss={{
                            backgroundColor: 'lightblue',
                            borderWidth: '2px',
                            borderStyle: 'solid',
                            borderColor: 'blue',
                            borderRadius: '4px',
                        }}
                        renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                            return <MenuItem
                                key={el.type}
                                disabled={el.type === "delete" && (row.original.optimizationState !== 'CALCULATION'
                                    && row.original.optimizationState !== 'EXPECTATION'
                                    && row.original.optimizationState !== 'NOT_CUTTING_REQUESTS')}
                                onClick={() => {
                                    el.handler(row.original)
                                    closeMenu();
                                }}
                                sx={{
                                    margin: "0 8px",
                                    borderRadius: "4px",
                                    "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                                }}
                            >
                                {el.text}
                            </MenuItem>
                        })}
                        localization={MRT_Localization_RU}
                    />
                </LocalizationProvider>
                <ModalUpdateStatus
                    title={'Обновить статус'}
                    data={data}
                    setData={setData}
                    open={updateModalOpen}
                    handleClose={handleClose}
                    currentEditRowId={currentEditRowId}
                    values={currentEditRowData}
                    setValues={setCurrentEditRowData}
                    currentAllowedStatuses={currentAllowedStatuses}
                    statusesList={optimizationStateStatuses}
                    field={'optimizationState'}
                    unableStatus={OptimizationService.unableStatus}
                    handleModalAlert={handleModalAlert}
                    handleSearchQuery={handleSearchQuery}
                    globalFilter={globalFilter}
                    loading={loading}
                    setLoading={setLoading}
                />
                <ModalOpenCreatePlanOrOptimization
                    label={'Название оптимизации'}
                    field={'number'}
                    values={newRowData}
                    setValues={setNewRowData}
                    title={'Создать оптимизацию'}
                    modalOpen={addModalOpen}
                    handleClose={() => setAddModalOpen(false)}
                    handleSubmit={createOptimization}
                    loading={loading}
                />
                <ModalConfirm
                    title={isCalculation ? "Подтвердить создание расчетных карт?" : "Подтвердить создание карт?"}
                    modalOpen={createCuttingMapsModalOpen}
                    handleClose={handleCloseCuttingMaps}
                    handleSubmit={handleSubmitCreateCuttingMaps}
                    action={"Подтвердить"}
                    loading={loading}>
                    <Typography>
                        {isCalculation ? 'Вы подтверждаете создание расчетных карт' : 'Вы подтверждаете создание карт'}
                        <br/>
                        для оптимизации {currentEditRowData?.number ?? 'не занумерован'}
                    </Typography>
                </ModalConfirm>
            </Box>
        );
    }
;

export default OptimizationTable;